var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76001 7.22006V16.7901C3.76001 18.7501 5.89001 19.9801 7.59001 19.0001L11.74 16.6101L15.89 14.2101C17.59 13.2301 17.59 10.7801 15.89 9.80006L11.74 7.40006L7.59001 5.01006C5.89001 4.03006 3.76001 5.25006 3.76001 7.22006Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.24 18.9301C19.83 18.9301 19.49 18.5901 19.49 18.1801V5.82007C19.49 5.41007 19.83 5.07007 20.24 5.07007C20.65 5.07007 20.99 5.41007 20.99 5.82007V18.1801C20.99 18.5901 20.66 18.9301 20.24 18.9301Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextVideo);
export default __webpack_public_path__ + "static/media/next-video.4d802f0e3e02121872fe7f8518cd6588.svg";
export { ForwardRef as ReactComponent };